import { Module } from '../Module';
import { SiteRoles } from '../ServerApi/types/ISiteRole';
import { getSessionManagementServiceInstance, SessionManagementService } from '../../sessionManagement/SessionManagementService';
import { filter } from '../../userManagement/services/filters/SiteRoleFilter';

export interface Permission {
  key: string;
  translate: string;
}

export interface ISiteRolePermissionsTableScope extends ng.IScope {
  siteRoles: string[];
  rows: ISiteRolePermissions[];
  permissions: Permission[];
}

Module.instance().directive('tbSiteRolePermissionsTable', <any[]>['$translate',
  ($translate: ng.translate.ITranslateService) => {
    let server = getSessionManagementServiceInstance();
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'siteRolePermissionsTable.html',
      link: (scope: ISiteRolePermissionsTableScope) => {
        scope.rows = SiteRolePermissions.permissionsForRoles(server);
        scope.permissions = SiteRolePermissions.permissions(server, $translate);
      }
    };
  }
]);

export interface ISiteRolePermissions {
  role: string;
  viewInteract?: boolean;
  subscriptionsAndAlerts?: boolean;
  webEdit?: boolean;
  publishViews?: boolean;
  createDataSource?: boolean;

  divider?: boolean;
}

export class SiteRolePermissions {

  public static viewInteract: string = 'viewInteract';
  public static subscriptionsAndAlerts: string = 'subscriptionsAndAlerts';
  public static webEdit: string = 'webEdit';
  public static publishViews: string = 'publishViews';
  public static createDataSource: string = 'createDataSource';

  private static availablePermissions: string[] = [SiteRolePermissions.viewInteract, SiteRolePermissions.subscriptionsAndAlerts, SiteRolePermissions.webEdit, SiteRolePermissions.publishViews];

  private static getPermission(permission: string, $translate: ng.translate.ITranslateService): Permission {
    return { key: permission, translate: $translate.instant(permission) };
  }

  public static permissions(sessionManagementService: SessionManagementService, $translate: ng.translate.ITranslateService): Permission[] {
    const permissions: Permission[] = [];
    SiteRolePermissions.availablePermissions.forEach(element => {
      permissions.push(SiteRolePermissions.getPermission(element, $translate));
    });
    if (sessionManagementService.hasCreatorTier()) {
      permissions.push(SiteRolePermissions.getPermission(SiteRolePermissions.createDataSource, $translate));
    }
    return permissions;
  }

  public static permissionsForRoles(sessionManagementService: SessionManagementService): ISiteRolePermissions[] {
    const siteRolePermissions: ISiteRolePermissions[] = [];

    // Creator
    if (sessionManagementService.hasCreatorTier()) {
      siteRolePermissions.push(
          {
            role:filter(SiteRoles.Creator),
            viewInteract: true,
            subscriptionsAndAlerts: true,
            webEdit: true,
            publishViews: true,
            createDataSource: true
          }
      );
    }

    // Explorer Can Publish
    siteRolePermissions.push(
        {
          role: filter(SiteRoles.ExplorerCanPublish),
          viewInteract: true,
          subscriptionsAndAlerts: true,
          webEdit: true,
          publishViews: true
        }
    );

    // Explorer
    siteRolePermissions.push(
        {
          role: filter(SiteRoles.Explorer),
          viewInteract: true,
          subscriptionsAndAlerts: true,
          webEdit: true
        }
    );

    // Viewer
    siteRolePermissions.push(
        {
          role: filter(SiteRoles.Viewer),
          viewInteract: true,
          subscriptionsAndAlerts: true
        }
    );

    // Unlicensed
    siteRolePermissions.push(
        {
          role: filter(SiteRoles.Unlicensed)
        }
    );

    return siteRolePermissions;
  }
}
